import type { Widget, WidgetTemplateListItem } from "../types";
import type { UserRole } from "@/modules/membership";
import WidgetGridItem from "./widget-grid-item";

export interface WidgetGridProps {
	widgets: Widget[];
	templates?: WidgetTemplateListItem[] | null;
	onDelete?: (id: string) => void;
	onEdit?: (id: string) => void;
	onStatusChange?: (id: string, status: string) => void;
	userRole?: UserRole | null;
}

export default function WidgetGrid({ widgets, templates, onDelete, onEdit, onStatusChange, userRole }: WidgetGridProps) {
	return (
		<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
			{widgets.map((widget) => (
				<WidgetGridItem key={widget.id} widget={widget} templates={templates} onDelete={onDelete} onEdit={onEdit} onStatusChange={onStatusChange} userRole={userRole} />
			))}
		</div>
	);
}
